/* @flow */

import * as React from 'react';
import {FlashMessages} from '../flash-messages';
import {JoyrideInfoBanner} from '../joyride-info-banner';
import {ScrollShadow} from './scroll-shadow';

import styles from './form-wrapper.css';

type Props = {
    icon: React.ComponentType<*>,
    footer: React.Element<any>,
    /** If full height, we do not include shadows */
    isFullHeight?: boolean,
    children?: any,
};

type State = {
    scrollShadowTop: boolean,
    scrollShadowBtm: boolean,
};

export class FormWrapper extends React.PureComponent<Props, State> {
    scrollContainerRef: ?HTMLElement;

    constructor(props: Props) {
        super(props);
        this.state = {
            scrollShadowBtm: true,
            scrollShadowTop: false,
        };
    }

    render() {
        const Icon = this.props.icon;

        // The first child is treated differently, because it's put next to the icon
        const firstChild = React.Children.map(this.props.children, (child, i) => {
            // Ignore all but the first child
            if (i !== 0) return;

            return child;
        });
        const restChildren = React.Children.map(this.props.children, (child, i) => {
            // Ignore the first child, or if the child doesn't exist for
            // some reason (ternaries can produce `undefined`)
            if (i < 1 || !child) return;

            return React.cloneElement(child, {
                className: styles['flex-row'],
            });
        });

        return (
            <div styleName='styles.form-content'>
                <div
                    ref={(node) => {
                        this.scrollContainerRef = node;
                    }}
                    styleName='styles.scroll-container'
                    onScroll={this.handleScroll}
                >
                    <JoyrideInfoBanner />
                    <div
                        id='entity-form-body'
                        styleName={
                            this.props.isFullHeight
                                ? 'styles.form-body--full-height'
                                : 'styles.form-body'
                        }
                    >
                        <div styleName='styles.flex-row'>
                            <div styleName='styles.icon-container'>
                                <Icon styleName='styles.icon' size={75} />
                            </div>
                            <div>{firstChild}</div>
                        </div>
                        {restChildren}
                    </div>
                </div>

                {this.props.footer}
                {!this.props.isFullHeight ? (
                    <React.Fragment>
                        <ScrollShadow orientation='top' isActive={this.state.scrollShadowTop} />
                        <ScrollShadow orientation='bottom' isActive={this.state.scrollShadowBtm} />
                    </React.Fragment>
                ) : null}

                <FlashMessages />
            </div>
        );
    }

    handleScroll = () => {
        const scrollContainerNode = this.scrollContainerRef;

        if (!scrollContainerNode) return;

        const {offsetHeight, scrollHeight, scrollTop} = scrollContainerNode;

        const state = {
            scrollShadowTop: scrollTop > 0,
            scrollShadowBtm: scrollHeight - offsetHeight !== scrollTop,
        };

        // Avoid calling setState on every mousewheel tick.
        const updateShadows =
            state.scrollShadowTop !== this.state.scrollShadowTop ||
            state.scrollShadowBtm !== this.state.scrollShadowBtm;

        if (updateShadows) this.setState(state);
    };
}
